import {
  Box,
  Container,
  Flex,
  HStack,
  Icon,
  Text,
  Link,
} from '@chakra-ui/react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { RiRocketLine } from 'react-icons/ri';
import dayjs from 'dayjs';

// The priority solution pages, linked from every marketing page as real <a href> links so
// search engines follow them and weigh these pages above the rest.
const SOLUTION_LINKS = [
  { label: 'Restaurants & Hospitality', path: '/industries/restaurants' },
  { label: 'Manufacturing', path: '/industries/manufacturing' },
  { label: 'Events Management', path: '/industries/events' },
  { label: 'Field Agent Tracking', path: '/industries/field-agents' },
  { label: 'Team Tasks on WhatsApp', path: '/whatsapp-task-management' },
];

export function MarketingFooter() {
  const navigate = useNavigate();

  return (
    <Box py={8} borderTop="1px" borderColor="border-default" bg="bg-surface">
      <Container maxW="7xl">
        <Flex
          as="nav"
          aria-label="Solutions"
          wrap="wrap"
          justify="center"
          columnGap={6}
          rowGap={2}
          fontSize="sm"
          pb={6}
          mb={6}
          borderBottom="1px"
          borderColor="border-default"
        >
          {SOLUTION_LINKS.map(link => (
            <Link
              key={link.path}
              as={RouterLink}
              to={link.path}
              color="text-secondary"
              _hover={{ color: 'brand.500' }}
            >
              {link.label}
            </Link>
          ))}
        </Flex>
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align="center"
          gap={4}
        >
          <HStack spacing={2}>
            <Icon as={RiRocketLine} w={6} h={6} color="brand.500" />
            <Text fontSize="sm" color="text-secondary">
              © {dayjs().format("YYYY")} TaskEye is a product of Cano Partners. All rights reserved.
            </Text>
          </HStack>
          <HStack spacing={6} fontSize="sm">
            <Link
              color="text-secondary"
              cursor="pointer"
              _hover={{ color: 'brand.500' }}
              onClick={() => navigate('/privacy')}
            >
              Privacy Policy
            </Link>
            <Link
              color="text-secondary"
              cursor="pointer"
              _hover={{ color: 'brand.500' }}
              onClick={() => navigate('/terms')}
            >
              Terms of Service
            </Link>
            <Link
              color="text-secondary"
              cursor="pointer"
              _hover={{ color: 'brand.500' }}
              onClick={() => navigate('/#demo-form')}
            >
              Contact
            </Link>
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
}
